export const FAVORITE_NEWS_APPLY_CATEGORIES_FILTER = 'FAVORITE_NEWS_APPLY_CATEGORIES_FILTER';
export const FAVORITE_NEWS_REMOVE_CATEGORIES_FILTER = 'FAVORITE_NEWS_REMOVE_CATEGORIES_FILTER';
export const FAVORITE_NEWS_REMOVE_CATEGORY_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_CATEGORY_FROM_FILTER';
export const FAVORITE_NEWS_APPLY_DATES_RANGE_FILTER = 'FAVORITE_NEWS_APPLY_DATES_RANGE_FILTER';
export const FAVORITE_NEWS_REMOVE_DATES_RANGE_FILTER = 'FAVORITE_NEWS_REMOVE_DATES_RANGE_FILTER';
export const FAVORITE_NEWS_APPLY_SEARCH_FILTER = 'FAVORITE_NEWS_APPLY_SEARCH_FILTER';
export const FAVORITE_NEWS_REMOVE_SEARCH_ITEM = 'FAVORITE_NEWS_REMOVE_SEARCH_ITEM';
export const FAVORITE_NEWS_REMOVE_SEARCH_FILTER = 'FAVORITE_NEWS_REMOVE_SEARCH_FILTER';
export const FAVORITE_NEWS_APPLY_ADDITIONAL_FILTER = 'FAVORITE_NEWS_APPLY_ADDITIONAL_FILTER';
export const FAVORITE_NEWS_REMOVE_ADDITIONAL_FILTER = 'FAVORITE_NEWS_REMOVE_ADDITIONAL_FILTER';
export const FAVORITE_NEWS_REMOVE_ADDITIONAL_ITEM = 'FAVORITE_NEWS_REMOVE_ADDITIONAL_ITEM';
export const FAVORITE_NEWS_REMOVE_COMPANY_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_COMPANY_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_PERSON_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_PERSON_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_REGION_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_REGION_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_SOURCE_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_SOURCES_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_TONALITY_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_TONALITY_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_SUBJECTIVITY_FROM_FILTER = 'FAVORITE_NEWS_REMOVE_SUBJECTIVITY_FROM_FILTER';
export const FAVORITE_NEWS_REMOVE_ALL_FILTERS = 'FAVORITE_NEWS_REMOVE_ALL_FILTERS';



// WEBPACK FOOTER //
// ./src/redux_related/favoriteNewsFilters/actions.js